// Optimized Color Swatches for Shopify using Metafield JSON (No fetch calls)
if (!window.colorSwatchesInitialized) {
  window.colorSwatchesInitialized = true;

  const criticalCSS = `
    .swatches-scroll-wrapper {
      max-width: calc(4.5 * 36px);
      overflow: hidden;
      text-align: left !important; /* Force left alignment */
    }
    @media screen and (max-width: 768px) {
      .swatches-scroll-wrapper {
        max-width: none;
      }
    }
    .color-swatches-container {
      display: flex !important;
      justify-content: flex-start !important;
      align-items: center !important;
      gap: 6px !important;
      overflow-x: auto !important;
      overflow-y: hidden !important;
      -webkit-overflow-scrolling: touch !important;
      scrollbar-width: none !important;
      text-align: left !important;
      cursor: grab;
    }
    .color-swatches-container:active {
      cursor: grabbing;
    }
    .color-swatches-container::-webkit-scrollbar {
      display: none;
    }
    .color-swatch {
      flex: 0 0 auto !important;
      width: 30px !important;
      height: 30px !important;
      cursor: pointer !important;
      background-size: cover !important;
      background-position: center !important;
      border: 1px solid #e0e0e0 !important;
      transition: all 0.2s ease !important;
      border-radius: 0px;
      user-select: none;
      -webkit-user-select: none;
    }
    .color-swatch.active {
      transform: scale(1.1) !important;
    }
    .more-swatches-button {
      font-size: 13px;
      padding: 0;
      border: none;
      background: none;
      cursor: pointer;
      white-space: nowrap;
      flex-shrink: 0;
      text-decoration: none;
      color: #000000;
      user-select: none;
      -webkit-user-select: none;
    }
    .variant-overlay-image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      transition: opacity 0.3s ease;
      object-fit: contain;
    }
    .variant-overlay-image.active {
      opacity: 1;
    }
    
    /* CRITICAL FIX: Force block display for proper positioning */
    product-card[data-has-color-swatches="true"] .product-card__info {
      display: block !important;
    }
    
    @media screen and (min-width: 769px) {
      .swatches-scroll-wrapper {
        margin-right: auto !important;
        transform: translateX(0) !important;
      }
      .color-swatches-container {
        justify-content: left !important;
      }
      .color-swatch {
        margin-bottom: 8px;
      }
    }
    
    @media screen and (max-width: 768px) {
      .color-swatch {
        width: 18px !important;
        height: 18px !important;
      }
    }
  `;

  const styleTag = document.createElement("style");
  styleTag.textContent = criticalCSS;
  document.head.appendChild(styleTag);

  function enableHorizontalDrag(container) {
    let isDown = false, startX, scrollLeft;
    container.addEventListener("mousedown", (e) => {
      isDown = true;
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
      container.style.cursor = "grabbing";
    });
    container.addEventListener("mouseleave", () => {
      isDown = false;
      container.style.cursor = "grab";
    });
    container.addEventListener("mouseup", () => {
      isDown = false;
      container.style.cursor = "grab";
    });
    container.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      container.scrollLeft = scrollLeft - (x - startX) * 2;
    });
  }

  const initColorSwatches = () => {
    document.querySelectorAll('product-card[data-has-color-swatches="true"]').forEach((card) => {
      if (card.hasAttribute("data-swatches-processed")) return;
      card.setAttribute("data-swatches-processed", "true");

      const infoContainer = card.querySelector(".product-card__info");
      if (!infoContainer) return;

      const wrapper = document.createElement("div");
      wrapper.className = "swatches-scroll-wrapper";
      const swatchesContainer = document.createElement("div");
      swatchesContainer.className = "color-swatches-container";
      wrapper.appendChild(swatchesContainer);
      infoContainer.insertBefore(wrapper, infoContainer.firstChild);

      enableHorizontalDrag(swatchesContainer);

      const currentHandle = card.getAttribute("handle");
      const data = card.getAttribute("data-related-color-products-full");
      if (!data) return;

      let products;
      try {
        products = JSON.parse(data);
        if (!Array.isArray(products)) throw new Error("Parsed data is not an array");
      } catch (e) {
        console.error("Invalid metafield JSON", e);
        return;
      }

      const isMobile = window.innerWidth <= 768;
      const maxVisible = 3;

      const currentProduct = products.find(p => p.handle === currentHandle);
      const others = products.filter(p => p.handle !== currentHandle);
      const displayQueue = isMobile ? [currentProduct, ...others.slice(0, maxVisible - 1)] : [currentProduct, ...others];

      const originalImage = card.querySelector(".product-card__image--primary, .product-card__image");
      if (originalImage) {
        const overlayImage = document.createElement("img");
        overlayImage.className = "variant-overlay-image";
        overlayImage.src = originalImage.src;
        originalImage.parentNode.appendChild(overlayImage);
      }

      displayQueue.forEach(p => {
        if (!p || !p.handle || !p.swatch) return;

        const swatch = document.createElement("button");
        swatch.className = `color-swatch${p.handle === currentHandle ? " active" : ""}`;
        
        // FIX: Add width parameter for better image quality like the complex version
        const swatchImageUrl = p.swatch.includes("?") 
          ? `${p.swatch}&width=100` 
          : `${p.swatch}?width=100`;
        swatch.style.backgroundImage = `url(${swatchImageUrl})`;

        swatch.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();

          card.querySelectorAll(".color-swatch").forEach(s => s.classList.remove("active"));
          swatch.classList.add("active");

          const overlayImage = card.querySelector(".variant-overlay-image");
          if (overlayImage && p.featured_image) {
            // FIX: Add width parameter and srcset like the complex version
            const imgUrl = p.featured_image.includes("?")
              ? `${p.featured_image}&width=500`
              : `${p.featured_image}?width=500`;

            overlayImage.src = imgUrl;
            overlayImage.srcset = `
              ${imgUrl.replace("width=500", "width=184")} 184w,
              ${imgUrl} 500w
            `;
            overlayImage.classList.add("active");
          }

          const productUrl = `/products/${p.handle}`;
          card.querySelectorAll("a[href]").forEach(link => {
            if (link.href.includes("/products/")) {
              link.href = productUrl;
            }
          });

          card.setAttribute("handle", p.handle);
        });

        swatchesContainer.appendChild(swatch);
      });

      if (isMobile && others.length > maxVisible - 1) {
        const moreLink = document.createElement("a");
        moreLink.href = `/products/${currentHandle}`;
        moreLink.className = "more-swatches-button";
        moreLink.textContent = `+${others.length - (maxVisible - 1)} more`;
        swatchesContainer.appendChild(moreLink);
      }
    });
  };

  if (document.readyState === "complete") {
    initColorSwatches();
  } else {
    document.addEventListener("DOMContentLoaded", initColorSwatches);
  }
}